module.exports = __webpack_public_path__ + "img/login-background.5bfa4a92.png";